export function numberToString(num) {
  return `${num > 9 ? '' : 0}${num}`;
}

export function diff(date1, date2) {
  const d = Math.abs(date1.getTime() - date2.getTime());
  return Math.ceil(d / (1000 * 3600 * 24));
}

export function firstDay(date) {
  date.setDate(1);
  return date;
}

export function round(date) {
  date.setMilliseconds(0);
  date.setSeconds(0);
  date.setMinutes(0);
  date.setHours(0);
  return date;
}

const MMMM = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export function toString(date, mask) {
  if (!date) {
    return '';
  }
  let value = mask || 'dd.MM.yyyy';
  value = value.replace(/yyyy/g, date.getFullYear()
    .toString());
  value = value.replace(/MMMM/g, MMMM[date.getMonth()]);
  value = value.replace(/MM/g, numberToString(date.getMonth() + 1));
  value = value.replace(/dd/g, numberToString(date.getDate()));
  value = value.replace(/d/g, date.getDate()
    .toString());
  value = value.replace(/HH/g, numberToString(date.getHours()));
  value = value.replace(/H/g, date.getHours()
    .toString());
  const h = date.getHours() % 12 === 0 ? 12 : date.getHours() % 12;
  value = value.replace(/hh/g, numberToString(h));
  value = value.replace(/h/g, h.toString());
  value = value.replace(/mm/g, numberToString(date.getMinutes()));
  value = value.replace(/m/g, date.getMinutes()
    .toString());
  value = value.replace(/ss/g, numberToString(date.getSeconds()));
  value = value.replace(/s/g, date.getSeconds()
    .toString());
  value = value.replace(/a/g, date.getHours() > 12 ? 'am' : 'pm');
  value = value.replace(/A/g, date.getHours() > 12 ? 'AM' : 'PM');
  return value;
}

export function addDay(date, day) {
  date.setDate(date.getDate() + day);
  return date;
}

export function getDayName(v) {
  if (v === 1) return 'день';
  if (v > 1 && v < 5) return 'дня';
  return 'дней';
}

export default {
  diff,
  firstDay,
  round,
  toString,
  addDay,
};
